import { ShieldAlert } from 'lucide-react'

// Shown when the applicant closes the identity verification before completing it while
// running it on this computer (the Veriff frame reports CANCELED). Nothing has been
// submitted, so we reassure them and send them back to the previous step to start again.
const VerificationCanceledDialog = ({ onConfirm }) => {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(4px)' }}
        >
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">

                <div className="px-7 pt-8 pb-6 text-center">
                    <div className="flex justify-center mb-5">
                        <div className="w-16 h-16 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center">
                            <ShieldAlert className="w-8 h-8 text-amber-500" />
                        </div>
                    </div>

                    <h2 className="text-xl font-bold text-gray-800 mb-2">
                        Verification Not Completed
                    </h2>
                    <p className="text-gray-600 text-sm leading-relaxed">
                        Your identity verification was closed before it could be completed, so
                        no information has been submitted. To continue, please return to the
                        previous step and start the verification again whenever you are ready.
                    </p>
                </div>

                <div className="px-7 pb-7">
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="w-full py-3 rounded-xl text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 active:scale-[0.98] transition-all"
                    >
                        Return to Previous Step
                    </button>
                </div>

            </div>
        </div>
    )
}

export default VerificationCanceledDialog
